import * as React from "react";
import classNames from "classnames";
import { ClientAdvancedSearch } from "./ClientAdvancedSearch";
import { IOrganisationSearchQuery } from "../Action/OrganisationSearchAction";
import { ICustomerSearchQuery } from "../Action/CustomerSearchAction";
import { IBasicSearchQuery } from "../Action/AccountSearchAction";
import { clientTypeEnum } from "../Resource/Content";

interface IClientQuickSearchProps {
    cssWrapper?: string;
    onSearch: (query: IOrganisationSearchQuery | ICustomerSearchQuery | IBasicSearchQuery) => void;
    clientType: clientTypeEnum;
    isSearching: boolean;
}

export const ClientQuickSearch = (props: IClientQuickSearchProps) => {
    const cssWrapper = classNames("advanced-search", props.cssWrapper);

    return (
        <>
            <div className={cssWrapper}>
                <ClientAdvancedSearch
                    isSearching={props.isSearching}
                    onSearch={props.onSearch}
                    clientType={props.clientType}
                />
            </div>
        </>
    );
};
